import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Bug, Loader2, Send } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export default function ReportProblemButton() {
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [sending, setSending] = useState(false);
  const send = async () => {
    if (msg.trim().length < 5) { toast.error("Conte um pouco mais sobre o problema"); return; }
    setSending(true);
    try {
      await api.post("/school/problem-reports", { message: msg.trim(), page: loc.pathname });
      toast.success("Recebemos! A equipe AMC vai verificar.");
      setMsg("");
      setOpen(false);
    } catch (e) { toast.error(e?.response?.data?.detail || "Não foi possível enviar agora"); }
    finally { setSending(false); }
  };
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="report-problem-btn"
        className="fixed z-40 left-3 bottom-[4.5rem] md:bottom-5 md:left-5 inline-flex items-center gap-2 pl-2 pr-3.5 h-11 rounded-full bg-[#0f172a] text-white shadow-xl shadow-slate-900/30 hover:bg-[#1e293b] active:scale-95 transition-transform">
        <span className="w-7 h-7 rounded-full bg-amber-400 flex items-center justify-center"><Bug className="w-4 h-4 text-[#0f172a]" strokeWidth={2.5} /></span>
        <span className="text-[12px] font-black leading-tight">Encontrou um<br className="md:hidden" /> problema?</span>
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md rounded-3xl" data-testid="report-problem-dialog">
          <DialogHeader>
            <DialogTitle className="font-heading text-[#1e3a8a] flex items-center gap-2"><Bug className="w-5 h-5 text-amber-500" /> Encontrou um problema?</DialogTitle>
            <DialogDescription>Conte o que aconteceu. A mensagem vai direto para a equipe AMC, junto com a tela em que você está.</DialogDescription>
          </DialogHeader>
          <Textarea value={msg} onChange={(e) => setMsg(e.target.value)} maxLength={2000} rows={5} autoFocus
            placeholder="Ex.: cliquei em Aprovar e nada aconteceu" data-testid="report-problem-input" />
          <Button onClick={send} disabled={sending} data-testid="report-problem-send" className="h-11 rounded-xl bg-[#7c3aed] hover:bg-[#6d28d9] text-white font-bold">
            {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4 mr-1" />} Enviar para a AMC
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
